export default "__VITE_ASSET__2bbe0168__"